var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueDropzone',{ref:"drop",staticClass:"drop",attrs:{"id":`drop${_vm.$uId}`,"options":_vm.dropzoneOptions},on:{"vdropzone-file-added":function($event){_vm.$emit('upload', $event); _vm.clear()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }